import { createFileRoute } from '@tanstack/react-router'
import ProjectPage, { VALID_SECTION_IDS } from '../pages/ProjectPage/ProjectPage'
import { ProjectLoader } from '../components/loaders'

type ProjectSearchParams = {
  tab?: 'overview' | 'checkplan' | 'phase' | 'resource' | 'deliverables'
  section?: string
  taskId?: number
}

const VALID_TABS = ['overview', 'checkplan', 'phase', 'resource', 'deliverables']

export const Route = createFileRoute('/project/$projectId')({
  component: ProjectPage,
  validateSearch: (search: Record<string, unknown>): ProjectSearchParams => {
    const tab = search.tab as string
    const section = search.section as string
    const taskId = Number(search.taskId)

    return {
      tab: (tab && VALID_TABS.includes(tab) ? tab : 'overview') as ProjectSearchParams['tab'],
      section: section && VALID_SECTION_IDS.has(section) ? section : undefined,
      taskId: Number.isFinite(taskId) && taskId > 0 ? taskId : undefined,
    }
  },
  pendingComponent: ProjectLoader,
})
